import { useIntl } from 'react-intl'
import styled from 'styled-components'

import { statusMessages } from './messages'
import { STATUS } from './constants'

const Status = styled.div<TSFixMe>`
  text-transform: capitalize;
  font-weight: 500;
  white-space: nowrap;

  ${({ status }): TSFixMe => {
    let color

    switch (status) {
      case STATUS.SCHEDULED:
        color = '#5ebbb5'
        break
      case STATUS.EXPIRED:
        color = '#5d5c70'
        break
      case STATUS.ACTIVE:
        color = '#64bb5e'
        break
      case STATUS.INACTIVE:
        color = '#ad5da6'
        break
    }

    return `color: ${color};`
  }}
`

export const CampaignStatus = ({ status }: TSFixMe): TSFixMe => {
  const intl = useIntl()

  if (statusMessages[status]) {
    return <Status status={status}>{intl.formatMessage(statusMessages[status])}</Status>
  }

  return <div>{status}</div>
}
